'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var WEEKDAYS_LONG = {
  ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  it: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
  de: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnertag', 'Freitag', 'Samstag']
};
var WEEKDAYS_SHORT = {
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  it: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
  de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']
};
var MONTHS = {
  ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};
var FIRST_DAY_OF_WEEK = {
  ru: 1,
  it: 1,
  de: 1
}; // Translate aria-labels

var LABELS = {
  ru: {
    nextMonth: 'следующий месяц',
    previousMonth: 'предыдущий месяц'
  },
  it: {
    nextMonth: 'Prossimo mese',
    previousMonth: 'Mese precedente'
  },
  de: {
    nextMonth: 'nächster Monat',
    previousMonth: 'voriger Monat'
  }
};
exports.WEEKDAYS_LONG = WEEKDAYS_LONG;
exports.WEEKDAYS_SHORT = WEEKDAYS_SHORT;
exports.FIRST_DAY_OF_WEEK = FIRST_DAY_OF_WEEK;
exports.LABELS = LABELS;
exports.MONTHS = MONTHS;